module.exports = __webpack_public_path__ + "images/feature/recycle-2-67949b34eb44c8d0dee974c8b4659948.png";